import Immutable from 'immutable';
import {
  GET_ITINERARY_SEGMENT,
  CLEAR_ITINERARY_SEGMENT,
  FLAG_GETTING_ITINERARY_SEGMENT,
  GET_ITINERARY_INCIDENTS,
  CLEAR_ITINERARY_INCIDENTS,
  FLAG_GETTING_ITINERARY_INCIDENTS,
} from '../../../actions/types/supervision-control/ItineraryIncident';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  itinerary: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  itineraryIncident: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ITINERARY_SEGMENT:
      return state.setIn(['itinerary', 'loading'], action.payload);
    case GET_ITINERARY_SEGMENT:
      return state.setIn(['itinerary', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_SEGMENT:
      return state.setIn(['itinerary', 'content'], Immutable.Map());
    case FLAG_GETTING_ITINERARY_INCIDENTS:
      return state.setIn(['itineraryIncident', 'loading'], action.payload);
    case GET_ITINERARY_INCIDENTS:
      return state.setIn(['itineraryIncident', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_INCIDENTS:
      return state.setIn(['itineraryIncident', 'content'], Immutable.Map(COLLECTION_SHAPE));
    default:
      return state;
  }
}
